import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=307045f5&"
import script from "./TaskTable.vue?vue&type=script&lang=js&"
export * from "./TaskTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports